import { render, staticRenderFns } from "./UserPassive.vue?vue&type=template&id=190d64b4&scoped=true"
import script from "./UserPassive.vue?vue&type=script&lang=js"
export * from "./UserPassive.vue?vue&type=script&lang=js"
import style0 from "./UserPassive.vue?vue&type=style&index=0&id=190d64b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190d64b4",
  null
  
)

export default component.exports